import { state, updateCurrentRoute } from '../lib/state.js';
import { calculateRouteForPoints } from '../services/route-service.js';
import { els } from '../app/dom.js';
import { setStatus, sectionDistanceKm } from '../lib/app-helpers.js';
import { calculatorMeta } from './registry.js';

export async function prepareSectionMetrics(section,adjective){
  let preparedSection=section;
  if(sectionDistanceKm(preparedSection)===null){
    setStatus(els.extensionStatus,`Obliczam rzeczywisty dystans ${adjective} odcinka…`,'working');
    try{
      const metrics=await calculateRouteForPoints(preparedSection.points);
      preparedSection={...preparedSection,...metrics};
      const sections=state.currentRoute.sections.map(item=>item.id===preparedSection.id?preparedSection:item);
      updateCurrentRoute({sections,dirty:true});
    }catch(error){
      setStatus(els.extensionStatus,`Nie udało się ustalić dystansu trasy: ${error.message}`,'error');
      return null;
    }
  }
  return preparedSection;
}

export function serverCalculatorLabel(calculatorKey){
  return calculatorKey==='etoll-pl'?'e-TOLL':'kalkulator';
}

export function browserlessCalculatorLabel(calculatorKey){
  return calculatorMeta(calculatorKey)?.name||calculatorKey||'kalkulator';
}

